import Dev from "../../assets/image/dev-clone.png";
import Qatros from "../../assets/image/qatros-landing.png";
import Btn_property from "../../assets/image/btn_property.png"
import Github from "../../assets/image/github.jpeg";
import Victoria from "../../assets/image/victoria.png";
import MuslimPergi from "../../assets/image/muslim_pergi.png"
import Github_user_search from "../../assets/image/user_search.png"
import Nexus from '../../assets/image/nexus.png'
import NPMJS from '../../assets/image/npmjs.png'

const dataProfile = [
  {
    id: 1,
    name: 'Projects',
    project: [
      {
        id: 1,
        title: "Revamp Victoria Internet Banking",
        image: Victoria,
        link: "https://ibvimo.victoriabank.co.id/login",
        year:  2023
      },

      {
        id: 2,
        title: "BTN Property",
        link: "https://www.btnproperti.co.id/",
        image: Btn_property,
        year: 2022
      },

      {
        id: 3,
        title: "muslimpergi.com",
        link: 'https://muslimpergi.com/aplikasi-jamaah/',
        image: MuslimPergi,
        year: 2021
      },

      {
        id: 4,
        title: "Qatros Landing Page",
        link: "https://qatros.com/",
        image: Qatros,
        year: 2021
      },

      {
        id: 5,
        title: "Data Vaksin Nasional",
        link: "https://data-vaksin-nasional.vercel.app/api",
        image: Github,
        year: 2022
      },
      
      {
        id: 6,
        title: "Analisis sentiment hashtag twitter",
        link: "https://github.com/Dickyrdiar/analysis-sentiment-",
        image: Github,
        year: 2020
      },
      
      {
        id: 7,
        title: "User github Search",
        link: 'https://user-github-search-eta.vercel.app/',
        image: Github_user_search,
        year: 2023
      }
    ],
  },

  {
    id: 2,
    name: 'RnD',
    RnD: [
      {
        title: 'Micro front-end boilerplate',
        link: '',
        image: Nexus
      }, 

      {
        title: 'Sephora Component',
        link: '',
        image: Nexus
      },

      {
        title: 'library search repo',
        link: '',
        image: NPMJS,
        link: 'https://www.npmjs.com/package/searchrepos'
      }
    ]
  }
];

export default dataProfile;







